// removed by extract-text-webpack-plugin
module.exports = {"hint":"qempo_Top_hint-2DoHfkG"};


//////////////////
// WEBPACK FOOTER
// ./src/elements/AddressForm/CourierType/Top.scss
// module id = 1298
// module chunks = 0